'use strict';

import { Modal } from 'bootstrap';

export default class GlobalModals {
    /**
     * Private member set in the initialize method
     * @type {boolean}
     */
    static #initialized = false;

    /**
     * @type {Modal}
     */
    static modalSuccess;

    /**
     * @type {Modal}
     */
    static modalInfo;

    /**
     * @type {Modal}
     */
    static modalError;

    /**
     * @type {Modal}
     */
    static modalWarning;

    /**
     * @type {Modal}
     */
    static modalSubscriptionAlert;

    /**
     * Initialize the modals - this only runs one time, then the modals are all configured and can be show
     * by just using the .show() or .hide() method
     */
    static initialize() {
        if (this.#initialized)
            //Only initialize one time
            return;

        //This was using window.configData.modals...
        let alerts = {}; //TODO: this is no longer being used, we need a different way of setting what modals to include

        if (alerts.modalSubscriptionAlert ?? false) {
            this.modalSubscriptionAlert = new Modal(
                document.getElementById('modal-alert-subscription')
            );
            if (alerts.modalSubscriptionAlert.message ?? false)
                document.getElementById('modal-alert-subscription-message').innerHTML =
                    alerts.modalSubscriptionAlert.message;

            if (alerts.modalSubscriptionAlert.showOnLoad) this.modalSubscriptionAlert.show();
        }

        let alertSelectors = [
            { name: 'modalSuccess', selector: 'modal-alert-success' },
            { name: 'modalWarning', selector: 'modal-alert-warning' },
            { name: 'modalInfo', selector: 'modal-alert-info' },
            { name: 'modalError', selector: 'modal-alert-error' }
        ]; //['modalSuccess', 'modalInfo', 'modalWarning', 'modalError'];
        for (let alert of alertSelectors) {
            const el = document.getElementById(alert.selector);
            if (el) {
                this[alert.name] = new Modal(el);

                //Todo: Also need to figure how to do this because it's also not done through window.configData any longer

                // if (alerts[alert].message ?? false) {
                //     document.getElementById(`${alerts[alert].id}-message`).innerHTML = alerts[alert].message;
                //     this[alert].show();
                // }
            }
        }

        this.#initialized = true;
    }

    /**
     * @param {Modal} modal
     * @param {string} message
     */
    static updateModalMessage(modal, message) {
        if (!this.#initialized) this.initialize();

        let name = 'success';
        if (modal === this.modalWarning) name = 'warning';
        else if (modal === this.modalInfo) name = 'info';
        else if (modal === this.modalError) name = 'error';
        else if (this.modalSubscriptionAlert) name = 'subscription';

        let msg = document.getElementById(`modal-alert-${name}-message`);
        msg.innerHTML = message;
    }

    /**
     *
     * @param {Modal} modal
     * @param {string} message
     */
    static updateAndShowModalMessage(modal, message) {
        if (!this.#initialized) this.initialize();

        this.updateModalMessage(modal, message);
        modal.show();
    }
}
